<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <div class="vx-row mb-6">
        <div class="vx-col w-full mb-6">
          <span>Produto Vinculado</span>
          <v-select :options="produtos" name="Produto" id="Produto" label="nomeProduto" class="w-full"
            v-model="formCadastro.idProduto" @input="preencheDadosProduto()" :reduce="(item) => item.idProduto"
            v-validate="{ required: true }" :state="validateState('Produto')" :class="validateClass('Produto')">
          </v-select>
          <div v-if="formCadastro.idProduto" class="text-right">
            <small><a href="javascript:void(0)" @click="preencheDadosProduto(true)">forçar atualização</a></small>
          </div>
        </div>

        <div class="vx-col w-full">
          <span>Nome Item</span>
          <vs-input class="w-full" name="Nome Item" id="Nome Item" v-model="formCadastro.nomeItem"
            v-validate="{ required: true }" :state="utilsList.validateState(
              this.veeFields,
              this.veeErrors,
              'Nome Item'
            )
              " :danger="!utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Nome Item'
              )
                " val-icon-danger="clear" danger-text="Preencha este Campo" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col mb-6">
          <label for="corHexa">Cor</label>
          <div class="input-group-color">
            <input type="color" size="large" class="w-full color-picker" name="corHexa" id="corHexa"
              v-on:change="changeThemeColor" v-model="formCadastro.corHexa" v-validate="{ required: false }"
              :state="validateState('corHexa')" :danger="validateClass('corHexa')" val-icon-danger="clear"
              danger-text="Preencha este Campo" icon-no-border />
            <vs-input class="w-full" name="corHexa" id="corHexa" @keyup.native="changeThemeColor"
              v-model="formCadastro.corHexa" v-validate="{ required: false }" :state="validateState('corHexa')"
              :danger="validateClass('corHexa')" val-icon-danger="clear" danger-text="Preencha este Campo"
              icon-no-border />
          </div>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/1 w-full">
          <div>Imagem (160 x 160)</div>
          <center v-if="formCadastro.imagem">
            <img :src="formCadastro.imagem" width="100%" style="max-width: 160px" />
          </center>
          <input id="fileUpload" type="file" hidden v-on:change="selecionaImagem" />
          <vs-button color="warning" type="border" class="mr-3 text-center" @click.stop.prevent="chooseFiles()">
            Escolher uma Imagem
            <feather-icon icon="UploadIcon" class="ml-2" />
            <Br />
            <vs-chip v-if="imagem" class="mt-3">
              <vs-avatar icon-pack="feather" icon="icon-file" />
              <span>{{ imagem }}</span>
            </vs-chip>
          </vs-button>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Valor Intangivel</span>
          <vs-switch color="success" v-model="formCadastro.valorIntangivel" style="width: 60px">
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6" v-if="!formCadastro.valorIntangivel">
        <div class="vx-col w-full">
          <span>Preço Anunciado</span>
          <money class="w-full vs-inputx vs-input--input large" name="Valor" id="Valor" v-model="formCadastro.valor"
            v-validate="{ required: true }" :state="utilsList.validateState(this.veeFields, this.veeErrors, 'Valor')
              " :danger="!utilsList.validateState(this.veeFields, this.veeErrors, 'Valor')
                " v-bind="valorMask"></money>
        </div>
      </div>

      <div class="vx-row mb-6" v-if="!formCadastro.valorIntangivel">
        <div class="vx-col w-full">
          <span>Valor Vender de Volta</span>
          <p class="span-sub">
            Este é o valor que o cliente paga quando não quer o item, fazemos
            sempre o calculo do (Valor da Caixa - 5%), apenas nas coins que é pago pelo valor anúnciado.
          </p>
          <money class="w-full vs-inputx vs-input--input large hidden" name="Valor Vender de Volta"
            id="Valor Vender de Volta" v-model="formCadastro.valorVenda" v-validate="{ required: true }" :state="utilsList.validateState(
              this.veeFields,
              this.veeErrors,
              'Valor Vender de Volta'
            )
              " :danger="!utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Valor Vender de Volta'
              )
                " v-bind="valorMask" :disabled="true"></money>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>ODD</span>
          <money class="w-full vs-inputx vs-input--input large" name="ODD" id="ODD" v-model="formCadastro.odd"
            v-validate="{ required: true }" :state="utilsList.validateState(this.veeFields, this.veeErrors, 'ODD')"
            :danger="!utilsList.validateState(this.veeFields, this.veeErrors, 'ODD')" v-bind="moneyOdd"></money>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Liberado apartir de:</span>
          <money class="w-full vs-inputx vs-input--input large" name="Liberado apartir de" id="Liberado apartir de"
            v-model="formCadastro.liberadoApartirDe" v-bind="valorMask"></money>
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          <span>Ordenação</span>
          <vs-input class="w-full" name="Ordenação" id="Ordenação" type="number" v-model="formCadastro.ordenacao"
            v-validate="{ required: true }" :state="utilsList.validateState(
              this.veeFields,
              this.veeErrors,
              'Ordenação'
            )
              " :danger="!utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Ordenação'
              )
                " val-icon-danger="clear" danger-text="Preencha este Campo" />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch color="success" v-model="formCadastro.status" style="width: 60px">
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <vs-alert v-if="$validator.errors.all().length > 0" color="danger" title="Atenção!!" active="true" class="my-3"
        style="height: auto !important">
        <ul>
          <li class="mb-2" v-for="error in $validator.errors.all()" :key="error.id">
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button color="warning" type="border" class="mr-3 mb-2" @click.stop.prevent="onReset">Cancelar</vs-button>
          <BotaoSubmit variant="success" :edit="this.dados.idItem == null ? false : true" :aguarde="aguardeCadastro">
          </BotaoSubmit>
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from "../../../../locale";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import vSelect from "vue-select";
import service from "../../../../services";
import BotaoSubmit from "../../../../components/BotaoSubmit";
import utilsList from "../../../../utils/list";
import cpfCnpj from "../../../../services/cpfCnpj";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import { Money } from "v-money";
export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    contadorRender: {
      type: Number,
    },
  },
  watch: {
    dados(value) {
      this.preencheForm();
    },
    contadorRender(value) {
      this.preencheForm();
    },
  },
  data() {
    return {
      moneyOdd: {
        decimal: ",",
        thousands: ".",
        precision: 8,
      },
      valorMask: {
        decimal: ".",
        thousands: "",
        precision: 2,
      },
      utilsList,
      aguardeCadastro: false,
      situacoes: ["Ativo", "Inativo"],
      languages: lang,
      funcoesValicao: null,
      files: new FormData(),
      produtos: [],
      imagem: null,
      temaCor: {},
      editorOption: {},
      formCadastro: {
        idItem: null,
        idProduto: null,
        idCaixa: this.$route.params.idCaixa,
        nomeItem: null,
        status: true,
        imagem: null,
        corHexa: null,
        valor: 0,
        valorIntangivel: null,
        odd: null,
        liberadoApartirDe: null,
        ordenacao: null,
        valorVenda: null,
      },
    };
  },
  methods: {
    async atualizaValorVenda() {
      try {
        const idCaixa = this.$route.params.idCaixa;
        const response = await service.getAll(
          "Caixa",
          {},
          `BuscarValorCaixaDesconto/${idCaixa}`
        );
        const valorDesconto = parseFloat(response.data.valorComDesconto);

        this.formCadastro.valorVenda = +valorDesconto.toFixed(2);
        console.log("✅ ValorVenda fixado como:", this.formCadastro.valorVenda);
      } catch (e) {
        console.warn("❌ Erro ao buscar valor da caixa:", e);
        this.formCadastro.valorVenda = 0;
      }
    },
    preencheDadosProduto(force = false) {
      if (!this.formCadastro.idItem || force == true) {
        const prod = this.produtos.find(
          (x) => x.idProduto == this.formCadastro.idProduto
        );


        this.formCadastro.nomeItem = prod.nomeProduto;
        this.formCadastro.imagem = prod.imagem;
        this.formCadastro.corHexa = prod.corHexaDefault;
        this.formCadastro.valor = prod.valorEstimado;
        this.formCadastro.valorIntangivel = prod.valorIntangivel;
        this.imagem = prod.imagem;
      }
    },
    onEditorChange({ quill, html, text }) {
      console.log("editor change!", quill, html, text);
      this.formCadastro.descricao = html;
    },
    changeThemeColor(event) {
      const { value, name } = event.target;
      this.formCadastro.corHexa = value;
    },
    chooseFiles() {
      document.getElementById("fileUpload").click();
      //this.$refs.fileUploadBtn.click();
      console.log(document.getElementById("fileUpload"));
    },
    selecionaImagem(event) {
      console.log(event);
      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      console.log(files[0]);
      this.files.set("file", event.target.files[0], event.target.files[0].name);
      this.imagem = event.target.files[0].name;

      this.$vs.loading();
      service
        .upload("Upload", "CaixaItem", this.files)
        .then((response) => {
          this.formCadastro.imagem = response;
          console.log(response);
          this.$vs.loading.close();
          //this.onSubmit();
        })
        .catch((error) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: error,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    async preencheForm() {
      console.log(this.dados);

      if (this.dados.idItem) {

        console.log(`------`, typeof this.dados.valorVenda, this.dados.valorVenda)


        this.formCadastro.idItem = this.dados.idItem;
        this.formCadastro.idCaixa = this.dados.idCaixa;
        this.formCadastro.nomeItem = this.dados.nomeItem;
        this.formCadastro.imagem = this.dados.imagem;
        this.formCadastro.corHexa = this.dados.corHexa;
        this.formCadastro.valor = parseFloat(this.dados.valor);
        this.formCadastro.valorIntangivel = this.dados.valorIntangivel;
        this.formCadastro.odd = parseFloat(this.dados.odd);
        this.formCadastro.liberadoApartirDe = this.dados.liberadoApartirDe;
        this.formCadastro.ordenacao = this.dados.ordenacao;
        this.formCadastro.valorVenda = parseFloat(this.dados.valorVenda);
        this.formCadastro.idProduto = this.dados.idProduto;

        this.formCadastro.status = this.dados.deletedAt == null ? true : false;

        this.imagem = this.dados.imagem;

        await this.atualizaValorVenda();
      } else {
        this.resetForm();
        await this.atualizaValorVenda();
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    onSubmit() {
      var action = "Atualizar/" + this.formCadastro.idItem;
      var metodo = "put";
      var msgRetorno = "Dados Atualizados com sucesso";
      if (!this.formCadastro.idItem) {
        action = "Adicionar";
        metodo = "post";
        msgRetorno = "Item Adicionado com sucesso";
      }

      var objSend = { ...this.formCadastro };

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service[metodo]("CaixasItens", action, objSend)
            .then((res) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: `Operação Realizada com sucesso`,
                color: "success",
              });
              this.$emit("concluido");
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: error,
                color: "danger",
              });
            });
        }
      });
    },

    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll("g", {}, `${model}/list`).then((res) => {
        res.data.forEach((element) => {
          if (element.deletedAt == null)
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
        console.log(this.regionais);
      });
    },

    buscaDadosProdutos(filtrarpor = "ativo") {
      this.$vs.loading();

      var objSend = {
        filtrarpor: filtrarpor,
        idEmpresa: null,
      };

      service
        .post("Produtos", "Listar", objSend)
        .then((res) => {
          this.produtos = [];
          console.log(res.data);
          res.data.forEach((element) => {
            this.produtos.push(element);
          });
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.loading.close();
        });
    },

    resetForm() {
      this.formCadastro = {
        idItem: null,
        idCaixa: this.$route.params.idCaixa,
        nomeItem: null,
        status: true,
        imagem: null,
        corHexa: null,
        valor: 0,
        valorIntangivel: null,
        odd: null,
        liberadoApartirDe: null,
        ordenacao: null,
        valorVenda: null,
      };
    },
    onReset(evt) {
      this.$emit("cancel");

      this.resetForm();
    },
  },
  created() {
    this.$validator.localize("ptBr", locale);
  },
  mounted() {
    this.buscaDadosProdutos();

    const tentarAtualizar = () => {
      if (this.$route.params.idCaixa) {
        this.atualizaValorVenda();
      } else {
        setTimeout(tentarAtualizar, 100); // tenta novamente em 100ms
      }
    };

    tentarAtualizar();
  },
  components: {
    Datepicker,
    BotaoSubmit,
    "v-select": vSelect,
    Money,
    quillEditor,
  },
};
</script>
<!------------ END SCRIPT ------------>
<style scoped>
#fileInput {
  display: none;
}

.img label {
  width: 100%;
  font-weight: normal;
}

.img .containericone {
  text-align: center;
  border-radius: 10px;
  padding: 10px 20px;
  -webkit-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  width: min-content;
  margin-top: 25px;
  margin-left: 43%;
  border: 1px solid #ccc;
}

.img .icone {
  font-size: 50px;
  color: #333;
}

.input-group-color {
  display: flex !important;
  gap: 5px;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.color-picker {
  max-width: 2.5rem;
  height: 2.375rem;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 4px;
}

.span-sub {
  color: rgb(60, 60, 60);
  font-size: 11px;
  margin-bottom: 5px;
}
</style>
